export const magdalenaWaszak = {
    'mydrId': 'magdalenawaszak',
    'firstName': 'Magdalena',
    'lastName': 'Waszak',
    'profession': 'Psycholog',
    'avatar': 'magdalena-waszak.webp',
    'slug': 'psycholog-magdalena-waszak',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychology', 'consultation'],
    ]
}